import { render } from "./index.vue?vue&type=template&id=4fff72fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./styles/alarm-panel.css?vue&type=style&index=0&id=4fff72fa&scoped=true&lang=css"
import "./styles/alarm-panel-global.css?vue&type=style&index=1&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fff72fa"]])

export default __exports__